var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden",
        },
      ],
      staticClass: "input grid__cell",
      class: _vm.inputClasses,
    },
    [
      _c(
        "div",
        { staticClass: "input--text mg mg--b-5" },
        [
          _c(
            "ma-modal",
            { ref: `input${_vm.type}${_vm.name}`, attrs: { type: "large" } },
            [
              _c(
                "template",
                { slot: "modalContent" },
                [
                  _c("p", { staticClass: "headline-medium mg mg--b-2" }, [
                    _vm._v(_vm._s(_vm.$t("common.mapAction"))),
                  ]),
                  _c("ma-poligons", {
                    attrs: { lat: _vm.lat, lng: _vm.lng, type: "surface" },
                    on: { change: _vm.handlePolygonChange },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c("p", { staticClass: "text-small-bold black mg mg--b-1" }, [
            _vm._v(_vm._s(_vm.$t(_vm.literal))),
          ]),
          _c("div", { staticClass: "input__wrapper" }, [
            _c("input", {
              attrs: {
                name: _vm.name,
                type: "text",
                disabled: _vm.disabled,
                inputmode: "numeric",
              },
              domProps: { value: _vm.mapValue },
              on: {
                input: function ($event) {
                  return _vm.handleInput($event.target.value)
                },
                keydown: function ($event) {
                  return _vm.handleKeydown($event)
                },
                change: function ($event) {
                  return _vm.$emit("change", $event.target.value)
                },
              },
            }),
            _c(
              "span",
              { staticClass: "input__icon" },
              [
                _c("svgicon", {
                  attrs: { icon: "dossier", height: "18", color: "#FFFFFF" },
                }),
              ],
              1
            ),
          ]),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "text-small black text-link mg mg--t-1",
                on: { click: _vm.handleShowModal },
              },
              [_vm._v(_vm._s(_vm.$t("common.mapAction")))]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }